import { render, staticRenderFns } from "./CompanyPageContent.vue?vue&type=template&id=281e652e"
import script from "./CompanyPageContent.vue?vue&type=script&lang=js"
export * from "./CompanyPageContent.vue?vue&type=script&lang=js"
import style0 from "./CompanyPageContent.vue?vue&type=style&index=0&id=281e652e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports